<template>
  <div class="pharmacist" @click.stop="openYsf">
    <div class="font12 font_weight500 colo0 line-height17 btn_btn">
      联系客服
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    getSimpleUserInfo() {
      return this.$store.getters.getSimpleUserInfo;
    }
  },
  created() {
    if (!this.getSimpleUserInfo.id) {
      this.getUserData();
    }
  },
  data() {
    return {
      isSdkReady: false
    };
  },
  watch: {
    $route(res) {
      console.log(res);
      // const self = this;
      // eslint-disable-next-line no-undef
      // ysf("onready", function() {
      //   self.isSdkReady = true;
      // });
    }
  },
  mounted() {
    // console.log(this.$route.name)
    // const self = this;
    // // eslint-disable-next-line no-undef
    // ysf("onready", function() {
    //   self.isSdkReady = true;
    // });
  },
  methods: {
    getUserData() {
      this.$store
        .dispatch("mine/getSimpleUserInfo")
        .then(() => {})
        .catch(() => {});
    },
    openYsf() {
      this.$router.push("/customer");
      // // console.log(this.details)
      // const self = this;
      // // console.log("----", this.isSdkReady);
      // if (this.isSdkReady) {
      //   // eslint-disable-next-line no-undef
      //   ysf("config", {
      //     uid: this.getSimpleUserInfo.id,
      //     name: this.getSimpleUserInfo.username,
      //     success: function() {
      //       // console.log('success')
      //       if (self.$route.name === "product-detail") {
      //         // eslint-disable-next-line no-undef
      //         ysf("product", {
      //           show: 1,
      //           title: "title",
      //           desc: "desc",
      //           picture: "picture",
      //           url: window.location.href,
      //           success: function() {
      //             // console.log('product-success')
      //             // 成功回调
      //             // eslint-disable-next-line no-undef
      //             ysf("open");
      //           },
      //           error: function() {
      //             // 错误回调
      //             // handle error
      //           }
      //         });
      //       } else {
      //         // eslint-disable-next-line no-undef
      //         ysf("open");
      //       }
      //     },
      //     error: function() {
      //       console.log("error");
      //       // 错误回调
      //       // handle error
      //     }
      //   });
      // } else {
      //   this.$toast("客服繁忙，请稍后再试");
      // }
    }
  }
};
</script>

<style lang="less" scoped>
/* .pharmacist {
  position: fixed;
  bottom: 72px;
  right: 15px;
  width: 48px;
  height: 48px;
  font-size: 12px;
  background: rgba(0, 0, 0, 0.7);
  color: #fff;
  border-radius: 24px;
  padding: 4px;
  box-sizing: border-box;
  text-align: center;
  display: flex;
  flex-direction: column;
  cursor: pointer;
  z-index: 99999;
}
.pharmacist span:first-child {
  margin: auto auto 0 auto;
}
.pharmacist span:last-child {
  margin: 0 auto auto auto;
} */
.icon_list {
  padding-left: 4px;
  .left_icon {
    // display: block;
    width: 24px;
  }
}
</style>
